document.addEventListener('DOMContentLoaded', function () {
  const button = document.getElementById('direct-checkout-button');

  if (!button) return;

  button.addEventListener('click', async function () {
    const form = button.closest('form');

    if (!form) return;
    if (!form.reportValidity()) return;

    button.disabled = true;
    const originalText = button.textContent;
    button.textContent = '処理中...';

    try {
      const formData = new FormData(form);

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('商品を追加できませんでした');
      }

      window.location.href = '/checkout';

    } catch (error) {
      console.error(error);

      button.disabled = false;
      button.textContent = originalText;

      alert('エラーが発生しました。もう一度お試しください。');
    }
  });
});
